// extracted by mini-css-extract-plugin
export default {"topic":"topic_topic__iEuWM","trending_negative":"topic_trending_negative__GCPZg","trending_positive":"topic_trending_positive__wrr-H"};